<script setup>
import {ref} from "vue"

const title = ref(null)
const recent_days = ref(7)

const emit = defineEmits(['search'])

const options = [
    {label: '1 week', value: 7},
    {label: '1 month', value: 30},
    {label: '3 month', value: 90},
    {label: 'half year', value: 180},
    {label: 'all', value: null},
]


function search() {
    emit('search', {
      title: title.value,
      recent_days: recent_days.value,
    })
}

</script>

<template>
    <div class="w-full grid grid-cols-1 gap-2 items-center">
        <div class="items-center w-full">
            <input type="text" class="text-right rounded px-2 py-1 w-full" v-model="title" placeholder="search title">
        </div>
        <div class="w-full grid grid-cols-3 gap-2 items-center">
            <label class="text-center font-bold" for="recent">Publish time</label>
            <select class="w-full rounded border border-gray-400" id="recent" v-model="recent_days">
                <option v-for="option in options" :key="option.label" :value="option.value">{{ option.label}}</option>
            </select>
            <button @click="search" class="px-4 py-2 bg-indigo-400 text-white rounded hover:bg-indigo-700 cursor:pointer">Search</button>
        </div>
    </div>
</template>
